import React from "react";
import swal from "sweetalert";
import Page from "../components/page";
import AuthService from "../services/auth_service";

class Login extends React.Component {

  async handleClick() {
    swal("Cargando ...");
    const email = document.querySelector("#email") as HTMLInputElement;
    const password = document.querySelector("#password") as HTMLInputElement;
    const response = await new AuthService().login(email.value, password.value);
    swal.close();

    if (response === false) {
      swal({
        title: "Error",
        text: "Verifica la informacion que ingresaste",
      });
    } else {
      swal({
        icon: "success",
        title: "Redireccionando",
        timer: 500,
      });
    }
  }

  render() {
    return (
      <Page>
        <div className="card" style={{ width: "60%", margin: "10vh auto" }}>
          <div className="card-content">
            <div className="field">
              <label className="label">Correo Electronico</label>
              <div className="control">
                <input className="input" type="text" placeholder="Correo" id="email" />
              </div>
            </div>
            <div className="field">
              <label className="label">Contraseña</label>
              <div className="control">
                <input className="input is-success" type="password" placeholder="Contraseña" id="password" />
              </div>
            </div>
          </div>
          <button className="button is-primary is-light is-fullwidth" onClick={() => this.handleClick()}>Ingresar</button>
        </div>
      </Page>
    );
  }
}

export default Login;